module.exports = __webpack_public_path__ + "assets/pizza-f2ba50.svg";